import { render, staticRenderFns } from "./microphoneOn.vue?vue&type=template&id=86792f90&scoped=true&"
var script = {}
import style0 from "./microphoneOn.vue?vue&type=style&index=0&id=86792f90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86792f90",
  null
  
)

export default component.exports